import { Box, Grid, IconButton, Typography } from '@material-ui/core';
import {
  CoverageCatalog,
  CoverageCatalogResume,
  QuotationUnit,
} from 'data-layer-cr/dist/models';
import { colors } from 'design-system';
import { useState } from 'react';
import { HelpCircle } from 'react-feather';

// Hooks
import { useCoverageData } from 'src/hooks/useCoverageData';
// models
import { faHandHoldingCircleDollar } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ExemptionCoverageId } from '../IndividualCoverages/ExemptionCoverage';
import DeductibleHelpModal from './DeductibleHelpModal';
import InformationRow from './InformationRow';
import { useStyle } from './styles';

type Props = {
  coverageCatalogs: CoverageCatalog[];
  coverageCatalogResumes: CoverageCatalogResume[];
  unit: QuotationUnit;
  moneyType: string;
  packageOption: number;
  shouldPersonalize?: boolean;
  onChangeDeductible: (
    modifiedPackage: number,
    deductibleOption: number,
  ) => void;
};

const IndividualDeductiblesCard = ({
  coverageCatalogs,
  coverageCatalogResumes,
  unit,
  moneyType,
  packageOption,
}: Props): JSX.Element => {
  const classes = useStyle();

  const [modalOpen, setModalOpen] = useState(false);

  const { deductibleResume } = useCoverageData({
    coverageCatalogResumes,
    coverageCatalogs,
    unit,
    moneyType,
    packageOption: packageOption + 1,
  });

  return (
    <Box data-testid="individual-deductibles-card">
      <DeductibleHelpModal
        data-testid="deductible-help-modal"
        open={modalOpen}
        onCloseModal={() => setModalOpen(false)}
      />
      <Grid
        container
        className={classes.titleSection}
        justifyContent="space-between"
      >
        <Box display="flex" style={{ gap: '0.5rem' }}>
          <FontAwesomeIcon
            icon={faHandHoldingCircleDollar}
            color="#0D2E68"
            size="2xl"
          />
          <Typography className={classes.titleText} data-testid="title-text">
            Deducibles
          </Typography>
        </Box>
        <Box>
          <IconButton
            onClick={() => setModalOpen(true)}
            data-testid="helper-button"
          >
            <HelpCircle color={colors.bright_turquoise} size={24} />
          </IconButton>
        </Box>
      </Grid>

      <Box
        display="flex"
        flexDirection="column"
        marginTop="1rem"
        style={{ gap: '1rem' }}
      >
        {deductibleResume
          .filter((item) => item.code !== ExemptionCoverageId)
          .map(({ code, name, value, helperText, showHelper }) => (
            <InformationRow
              data-testid={`deductible-${code}`}
              key={code}
              description={name}
              value={value}
              helperText={helperText}
              showHelper={showHelper}
            />
          ))}
      </Box>
    </Box>
  );
};

export default IndividualDeductiblesCard;
